<template>
  <!-- An image upload that shows what will be saved: the chosen file, else the saved image
       (`current` URL), else "No image yet" — or a warning when the saved file can't be loaded. -->
  <div class="tn-image-field">
    <div class="tn-image-field__preview">
      <img v-if="src && !broken" :src="src" :alt="label" @error="broken = true">
      <div v-else class="tn-image-field__empty" :class="{ 'is-missing': broken }">
        <v-icon size="26">{{ broken ? 'mdi-image-broken-variant' : 'mdi-image-outline' }}</v-icon>
        <span>{{ broken ? 'Image file missing on the server — choose a new one' : 'No image yet' }}</span>
      </div>
    </div>
    <v-file-input
      :value="value"
      :label="current && !broken ? 'Replace ' + label.toLowerCase() : label"
      accept="image/png, image/jpeg, image/gif"
      outlined
      dense
      show-size
      prepend-icon=""
      prepend-inner-icon="mdi-image-plus"
      :hint="value ? 'Saved when you save the form' : 'PNG, JPG or GIF'"
      persistent-hint
      @change="$emit('input', $event || null)"
    ></v-file-input>
  </div>
</template>

<script>
export default {
  name: 'ImageField',
  props: {
    value: { type: File, default: null },
    current: { type: String, default: null },
    label: { type: String, default: 'Image' }
  },
  data () {
    return {
      fileUrl: null,
      broken: false
    }
  },
  computed: {
    src () {
      return this.fileUrl || this.current
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (file) {
        if (this.fileUrl) URL.revokeObjectURL(this.fileUrl)
        this.fileUrl = file ? URL.createObjectURL(file) : null
        this.broken = false
      }
    },
    current () {
      this.broken = false
    }
  },
  beforeDestroy () {
    if (this.fileUrl) URL.revokeObjectURL(this.fileUrl)
  }
}
</script>

<style lang="scss" scoped>
.tn-image-field {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
  margin-bottom: 18px;

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.tn-image-field__preview {
  overflow: hidden;
  height: 88px;
  border: 1px solid var(--tn-border);
  border-radius: 8px;
  background: var(--tn-subtle);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.tn-image-field__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 100%;
  padding: 6px 8px;
  color: var(--tn-muted);
  font-size: 11.5px;
  line-height: 1.3;
  text-align: center;

  &.is-missing {
    background: #FEF3F2;
    color: #B42318;

    .v-icon {
      color: #B42318 !important;
    }
  }
}
</style>
